import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  idFrom: "",
  idTo: "",
  substoreFrom: "",
  substoreTo: "",
  purchasenoteFrom: "",
  purchasenoteTo: "",
  datepurchaseFrom: null,
  datepurchaseTo: null,
  opt_tras_store_idFrom: "", 
  opt_tras_store_idTo: "",
  opt_tras_licenseplateFrom: "", 
  opt_tras_licenseplateTo: "",
  marcaFrom: "",
  marcaTo: "",
  modeloFrom: "",
  modeloTo: "",
  amountFROM:0,
  amountTO:0,
  paymentFromES: "",
  paymentToES: "",
  paymentFromEN: "",
  paymentToEN: ""
};

const filtersPurchaseDeliverySlice = createSlice({
  name: 'filtersPurchaseDelivery',
  initialState,
  reducers: {
    setFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { setFilters, resetFilters } = filtersPurchaseDeliverySlice.actions;
export default filtersPurchaseDeliverySlice.reducer;
